<template>
  <div class="e-video-thumb" :class="activeClass">
    <div class="e-video-thumb__progress" :style="progressStyle"></div>
  </div>
</template>

<script setup>
import { computed  } from 'vue'

const props = defineProps({
  progress: { default: 0, type: Number},
  active: { default: false, type: Boolean},
  title: { default: '', type: String},
  image: { default: '', type: String}
})

const progressStyle = computed(() => {
  return `--progress: ${props.progress}`
})

const activeClass = computed(() => {
  return props.active ? 'e-video-thumb--active' : ''
})
</script>